import script from "./ProjectComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectComment.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectComment.vue?vue&type=style&index=0&id=3284a3d1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3284a3d1"]])

export default __exports__